"use client"
import { createContext } from "react";

const ParamsContext = createContext<any>(null);

export default ParamsContext;
